import axios from "axios";


export const getUserDetails = async () => {
    try {
        const token = sessionStorage.getItem('accessToken');

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-user-info/`, {
            headers: { Authorization: `Bearer ${token}` },

        });
        return response.data; // Return response to handle it in the component
    } catch (err) {
        console.error('Error fetching user details:', err); // Log the error for debugging
    }
};


export const updateGraphPreferences = async (graphPrefs) => {
    try {
        const token = sessionStorage.getItem('accessToken');

        const response = await axios.patch(
            `${process.env.REACT_APP_API_URL}/api/graph-preferences/`,
            { graph_prefs: graphPrefs },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (err) {
        console.error('Error updating graph preferences:', err);
    }
};
